import { SupportedLanguagePath } from '@amzn/aws-marketing-experience-builder-template-types';
import { SUPPORTED_LOCALE_DATA } from './constants';
export function localizeUrl(host, path, locale) {
    const langPath = SUPPORTED_LOCALE_DATA[locale].path;
    if (langPath === SupportedLanguagePath.EN) {
        return `https://${host}${path}`;
    }
    return `https://${host}/${langPath}${path}`;
}
